

















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiCard from "@/components/common/AsiCard.vue";
import {Icon} from "@/helpers/icons";
import User from "@/models/user/User";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import {CompanyType, Permissions, Roles} from "@/helpers/constants";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiConfirmDialog from "@/components/common/AsiConfirmDialog.vue";
import {SnackbarMessage} from "@/models/SnackbarMessage";

@Component({
	components: {AsiConfirmDialog, AsiBtn, AsiContentContainer, AsiCard}
})
export default class UserCardRightsDriver extends Vue {

	@Prop({type: Object, default: null})
	public user!: User | null;

	@Prop({type: Array, required: true})
	public roles!: Roles[];

	@Prop({type: Array, required: true})
	public permissions!: Permissions[];

	private loadingRole: boolean = false;

	private get icon(): string {
		return this.hasRole ? Icon.yes : Icon.no;
	}

	private get iconBgColor(): string {
		return this.hasRole ? 'success' : 'error';
	}

	private get buttonColor(): string {
		return this.hasRole ? 'error' : 'success';
	}

	private get isAdmin(): boolean {
		return this.roles.includes(Roles.roleAdmin);
	}

	private get hasRole(): boolean {
		return this.roles.includes(Roles.roleDriver);
	}

	private get isInternalCompany(): boolean {
		return this.user?.company.type === CompanyType.internal;
	}

	private toggleRole(): void {
		if (this.user === null) return;

		this.loadingRole = true;
		if (!this.hasRole) {
			this.$userService.assignRole(this.user.id, Roles.roleDriver)
				.then(this.rightsChanged)
				.catch(this.updateError)
				.finally(() => this.loadingRole = false);
		} else {
			this.$userService.revokeRole(this.user.id, Roles.roleDriver)
				.then(this.rightsChanged)
				.catch(this.updateError)
				.finally(() => this.loadingRole = false);
		}
	}

	@Emit('rightsChanged')
	public rightsChanged(): void {
		return;
	}

	private updateError(): void {
		this.$store.commit('ui/showSnackbar', {
			message: this.$t('snackbar.updateError'),
			color: 'error',
		} as SnackbarMessage);
	}

}
